import { ReactNode, useState } from 'react';
import { QuoteContext } from '@src/contexts/quote-context';
import { Quote } from '@src/@types/quotes';

export const QuoteContextProvider = ({
  children,
  value,
}: {
  children: ReactNode;
  value: Quote;
}) => {
  const [quote, setQuote] = useState(value);

  return (
    <QuoteContext.Provider value={{ quote, setQuote }}>
      {children}
    </QuoteContext.Provider>
  );
};
